// extracted by mini-css-extract-plugin
export default {"content":"SignupPage_content__wAv5W","stepper":"SignupPage_stepper__0qRrv"};